var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrganizationWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.925,
    height: 19.722,
    viewBox: "0 0 19.925 19.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160685",
    "data-name": "Group 160685",
    transform: "translate(-136.06 -121.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160623",
    "data-name": "Group 160623",
    transform: "translate(137.032 122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160595",
    "data-name": "Group 160595",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "home-modern",
    d: "M7.356,20.78V15.905a1.082,1.082,0,0,1,1.036-1.122h2.08a1.082,1.082,0,0,1,1.036,1.122h0V20.78m0,0h4.152V3.322M11.507,20.78h6.92V10.527M1.82,20.78H3.2m16.616,0H3.2m-1.384-12L5.972,7.142M17.043,2.78l-1.384.542m0,6.2,2.768,1m1.384.5-1.384-.5M5.972,7.142V2.78H3.2v18M13.588,4.144l2.08-.822m-9.7,3.821L9.659,5.691",
    transform: "translate(-1.82 -2.78)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 0.521,
    cy: 0.521,
    r: 0.521,
    transform: "translate(9.165 1.528)",
    fill: "#787f88"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationWhiteIcon);
export default __webpack_public_path__ + "static/media/organization-white-icon.7344de9996f763222c19582b865d1498.svg";
export { ForwardRef as ReactComponent };